/**
 * Gameplay Constants
 *
 * @note These are remote-controlled via GameAnalytics!
 * The values will be overriden by the remove config.
 *
 * Keys need to be 1-16 characters.
 *
 * ## Shorthand Legend
 *
 * MP = "Multiplier"
 * I = "Interval"
 */
export const Constants = {
    gameId: 'Power-Fruits',
    /**
     * The default health multiplier. User for calculating the health of enemies.
     * Level * enemyHealthMP = baseHealth
     */
    enemyHealthMP: 20,

    /**
     * The default damage multiplier. Used for calculating the damage per level.
     * Level * enemyDamageMP = baseDamage
     */
    enemyDamageMP: 1.2,

    /**
     * The default attack interval. Used for calculating the time between attacks from enemies.
     * This is in milliseconds.
     */
    enemyAttackI: 1600,

    /**
     * The delay between starting the animation and actually hitting the player.
     * This is in milliseconds.
     */
    hitDelay: 300,

    /**
     * The duration of attack animation of the player.
     * This is in milliseconds.
     */
    attackAnimationDuration: 600,

    /**
     * The default attack cooldown. Used for calculating the time between attacks
     * from the player.
     */
    attackCooldown: 250,

    /**
     * The default energy regeneration rate. Used for calculating the rate at which
     * the player's energy regenerates.
     */
    energyRegenI: 1000,

    /**
     * The number of steps it takes to fully regenerate the player's energy.
     */
    energyFullSteps: 15,

    /**
     * The energy cost for a normal attack.
     */
    attackEnergyCost: 1,

    /**
     * The energy cost for a power attack.
     */
    powerEnergyCost: 5,

    /**
     * This constant represents the base amount of XP that is used as a starting point
     * in the formulas for both calculating the required XP for a given level and
     * determining the player's level from their current XP. It ensures that the level
     * calculation starts properly at level 1 and scales the XP requirements for
     * subsequent levels. Adjusting this value can make leveling up faster or slower.
     */
    xpRewardMP: 21,

    /**
     * This scaling factor influences the calculation of XP awarded to the player when
     * they defeat an enemy. The XP gained from a kill scales exponentially with
     * the enemy's level based on this constant. A higher value means players get
     * significantly more XP for defeating higher-level enemies, making the curve steeper.
     */
    xpkillRewardExponent: 1.5,

    /**
     * This constant determines the type of reward the player receives for defeating
     * an enemy. The player can receive either a linear or exponential amount of XP.
     */
    xpRewardType: 'exp' as 'exp' | 'lin',

    /** How much health the player gets per level */
    healthPerLevel: 10,

    /** How much health the player gets per stat point */
    healthPerStat: 5,

    /** How much energy the player gets per level */
    energyPerLevel: 10,

    /** How much energy the player gets per stat point */
    energyPerStat: 5,

    /** Design */

    /** How large the rewarded ad button is in the HUD */
    adButtonSize: 60,
    /** How many coins the ad rewards as base */
    adCoins: 250,
    /** Ad timeout in seconds */
    adTimeout: 30,

    /** How many coins the ad rewards per level */
    adCoinsLvl: 25,

    /** How many seconds the respawn will be delayed to motivate respawn*/
    respawnTimer: 3,
};
